import React from "react";
import { LocalVideoTrack } from "twilio-video";
import { Box, Divider, Grid, GridItem, SimpleGrid } from "@chakra-ui/react";
import { BiVideo, BiVideoOff } from "react-icons/bi";
import { BsGear } from "react-icons/bs";

import {
  DEFAULT_VIDEO_CONSTRAINTS,
  SELECTED_VIDEO_INPUT_KEY
} from "context/session/VideoProvider/constants";
import { useDevices, useVideoContext } from "hooks/session";
import VideoTrack from "../SessionCall/VideoTrack";
import { VideoButton } from "../SessionCall/Buttons";
import DeviceSelector from "./DeviceSelector";

const VideoPreview: React.FC = () => {
  const { localTracks, getLocalVideoTrack } = useVideoContext();
  const { videoInputDevices } = useDevices();
  const track = localTracks.find(track =>
    track.name.includes("camera")
  ) as LocalVideoTrack;

  const replaceTrack = (newDeviceId: string) => {
    window.localStorage.setItem(SELECTED_VIDEO_INPUT_KEY, newDeviceId);
    track.restart({
      ...(DEFAULT_VIDEO_CONSTRAINTS as {}),
      deviceId: { exact: newDeviceId }
    });
    getLocalVideoTrack();
  };

  return (
    <Grid
      bgColor="gray.800"
      borderRadius="8px"
      flexDirection="column"
      justifyContent="center"
      overflow="hidden"
      gridTemplateRows="1fr fit-content(100%)"
    >
      {track ? (
        <VideoTrack track={track} isLocal />
      ) : (
        <Box
          bgColor="gray.800"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <BiVideoOff size={100} />
        </Box>
      )}
      <Grid
        templateColumns="fit-content(100%) fit-content(100%) fit-content(100%) 1fr"
        justifyContent="center"
        alignItems="center"
        paddingY="0.5rem"
        paddingX="1rem"
        gap={3}
      >
        <BiVideo size="25px" />
        <VideoButton isSwitch />
        <Divider orientation="vertical" />
        <GridItem justifySelf="flex-end">
          <DeviceSelector
            icon={BsGear}
            deviceList={videoInputDevices}
            callback={replaceTrack}
          />
        </GridItem>
      </Grid>
    </Grid>
  );
};

export default VideoPreview;
